/** Presence rule shared with the importer: status, priority and flow text do not classify a sample. */
export function isValidationSample(row: { validationSample?: unknown } | null | undefined): boolean {
  return row != null && row.validationSample !== undefined && row.validationSample !== null;
}
